import React from 'react';
import { useProgrammationId } from 'containers/Programmations/atoms/progAtoms';
import SchoolyearRedirect from 'components/Redirect/SchoolyearRedirect';
import { useFirstMatiereId } from 'containers/Programmations/atoms/matieresAtoms';
import SpinnerComponent from 'components/Spinner/ScreenSpinner';
import { useLocation } from 'react-router-dom';

export function RedirectToFirstMatiere() {
  const firstMatiereId = useFirstMatiereId();
  const programmationId = useProgrammationId();
  const { search } = useLocation();
  if (!firstMatiereId) {
    return <SpinnerComponent />;
  }
  return (
    <SchoolyearRedirect
      to={`programmations/${programmationId}/matieres/${firstMatiereId}${search}`}
    />
  );
}
